import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { NotifyUsersInput } from './notify-users-input';
import { NotifyUsersService } from 'src/app/services/notify-users/notify-users.service';
import { ConfirmationModalComponent } from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import { NotifyUsersEmailListComponent } from '../notify-users-email-list/notify-users-email-list.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UserService } from 'src/app/services/user/user.service';
import AppConstants, {file_upload_dots_error, fileExtensionToIcon} from 'src/app/shared/common-components/AppConstants';
import { PreviewNotificationEmailComponent } from '../preview-notification-email/preview-notification-email.component';
import {MultiFileUploadService} from '../multi-file-upload/multi-file-upload-service.service';
import { concatMap, from, Observable, toArray } from 'rxjs';
import { FileUpload } from './file-upload';

@Component({
    selector: 'app-notify-users',
    templateUrl: './notify-users.component.html',
    styleUrls: ['./notify-users.component.css'],
    standalone: false
})

export class NotifyUsersComponent implements OnInit {
  notifyUsersForm : UntypedFormGroup;
  fileError = '';
  busType : string;
  usersType: string;
  usersSubType: string;
  apprType: string[];
  rfspInclude: boolean;
  uploadImage: boolean;
  organizationid: Number = -1;
  permission: string = "";
  notifyUsersin: NotifyUsersInput;
  uploadedFilesList: any[];
  uploadedFiles: any[];
  uploadedFilesSizes: any[];
  exceededUploadLimit: boolean;
  withinUploadLimit: boolean;
  fileCount: any;
  uploadLimit: number;
  sentEmails: boolean;
  viewRecipientButton: boolean;
  images : any[];
  emailRecipientList: any = [];
  banner : any;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  subjectPrefix: any;
  layoutCounter:number = 0;
  fileUploads: FileUpload[] = [];
  pathUploaded:string[]=[];

  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private notifyUsersService: NotifyUsersService,
    private userService: UserService,
    private tmssLoader: LoadingService,
    private modalService: BsModalService,
    private uploadService : MultiFileUploadService) {

   }

  ngOnInit(): void {
    this.tmssLoader.show();
    this.getUserDetails();
    this.busType = '';
    this.usersType = '';
    this.usersSubType = '';
    this.apprType = [];
    this.rfspInclude = false;
    this.exceededUploadLimit = false;
    this.withinUploadLimit = false;
    this.sentEmails = false;
    this.uploadImage = false;
    this.createForm();
    this.notifyUsersForm.get('bannerImage').setValue('TMSS_logo.gif');
    this.tmssLoader.hide();
  }

  getUserDetails() {
      this.userService.getCurrentUserDetails().subscribe((currentUser) => {
        if (AppConstants.isNotNullCondition(currentUser)) {
          this.organizationid = currentUser.organizationId
            ? currentUser.organizationId
            : -1;
          this.permission = currentUser.permissions;

        }
      });
    }

  createForm(){
    this.notifyUsersForm = this.fb.group({
      busType : new UntypedFormControl(''),
      usersType : new UntypedFormControl('',[Validators.required]),
      usersSubType : new UntypedFormControl('',[Validators.required]),
      apprType : new UntypedFormControl('All Approval Types'),
      rfspInclude : [false],
      emailSubject : new UntypedFormControl('',[Validators.required]),
      bannerImage: new UntypedFormControl(''),
      emailBody : new UntypedFormControl('',[Validators.required]),
      uploadImage : [false]
    })
  }
  businessTypeChange(event: any){
    this.busType = event;
    /* this.notifyUsersService.listOfImages(this.busType)
       .subscribe(images => {this.images = images});
    */
    this.initAfterBusTypeChange();

  }
  usersTypeChange(event: any){
    this.usersType = event;
    this.viewRecipientButton = false;
    this.initAfterUsersTypeChange();
  }
  userSubTypeChange(event: any){
    this.usersSubType = event;
    this.viewRecipientButton = true;
    this.initAfterUsersSubTypeChange();
    this.subjectPrefix = 'TMSS 2.0 (' + this.permission + ') -' ;
    this.notifyUsersForm.get('emailSubject').setValue(this.subjectPrefix);
  }
  apprTypeChange(event: any){
    this.apprType = (JSON.parse(JSON.stringify(this.notifyUsersForm.value)).apprType);
  }
  rfspChange(event: any){
    this.rfspChange = event;
  }
  rfspIncludeCheck(event){
    this.rfspInclude = event.target.checked;
  }
  bannerImageChange(event: any){
    this.banner = event;
  }
  gotResponseFromUploadImage(uploadImageResponse : boolean){
    if(uploadImageResponse){
      this.uploadImage = false;
      this.notifyUsersForm.get('uploadImage').setValue(false);
      this.notifyUsersService.listOfImages(this.permission)
       .subscribe(images => {this.images = images});
    }
  }
  updateUploadedFiles(filesList : any){
    this.uploadedFiles = filesList;
    this.uploadedFilesList = [];
    this.uploadedFilesSizes = [];
    this.exceededUploadLimit = false;
    this.withinUploadLimit = false;
    this.uploadLimit = 0.0;
    this.sentEmails = false;
    let j = 0;
    for(let i = 0; i < this.uploadedFiles.length; i++) {
      let myArr = this.uploadedFiles[i].split('~%');
      this.uploadedFilesList.push(myArr[0]);
      this.uploadedFilesSizes.push(myArr[1]);
      this.uploadLimit += +myArr[1];
      this.withinUploadLimit = true;
      this.fileCount = ++j;
    }
    if (this.uploadLimit > 40.00){
      this.exceededUploadLimit = true;
      this.withinUploadLimit = false;
    }
    this.uploadLimit = +this.uploadLimit.toFixed(3);
  }
  submit(){

      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to send out the email?';
      this.modalRef.content.title = 'Notify User';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssLoader.show();
          const files: File[] = this.fileUploads.map(fu => fu.file).filter((f): f is File => !!f);
          console.log(files);
          const loop$ = from(files).pipe(
            concatMap(item => this.upload(item)), // Process each item in order
            toArray() // Collect all results into an array when complete
          );

          loop$.subscribe({
            next: results => {
              // this.alertService.success("Emails are being sent out");
              const doneResults = results.filter(
                item => item.status && item.status.toLowerCase() === 'done'
              );
              console.log('Results:', doneResults)
              this.uploadedFilesList = doneResults;
              this.notifyUsersin = this.buildNotifyUsersInput();
              this.sendNotificationEmails();
              // this.tmssLoader.hide();
            },
            error:() => {
              console.log("ERROR while processing observation");
            },
            complete: () => {
              console.log('All items processed, do next execution here');
            }
          });
        }
      });



  }

  sendNotificationEmails() {
    this.notifyUsersService.sendEmails(this.notifyUsersin).subscribe({
      next: () => {
        this.alertService.success("Emails are being sent out");
        this.resetScreen();
        this.sentEmails = true;
        this.tmssLoader.hide();
      },
      error: () => {
        this.alertService.error("error while trying to send out emails");
        this.tmssLoader.hide();
      },
      complete: () => {
      }
    });
  }

  upload(file: File): Observable<any> {
    return this.uploadService.postMultiFile(file);
  }

  resetScreen(){
    this.notifyUsersForm.get('busType').setValue('');
    this.notifyUsersForm.get('bannerImage').setValue('TMSS_logo');
    this.notifyUsersForm.get('uploadImage').setValue(false);
    this.notifyUsersForm.get('emailSubject').setValue('');
    this.notifyUsersForm.get('emailBody').setValue('');
    this.uploadImage = false;
    this.busType ='';
    this.images = [];
    //move all child nodes.
    const container = document.getElementById('selected_files');
    if (container) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    }
    this.layoutCounter = 0;
    this.fileUploads = [];
    this.pathUploaded = [];
    this.initAfterBusTypeChange();
  }
  initAfterBusTypeChange(){
    this.notifyUsersForm.get('usersType').setValue('');
    this.viewRecipientButton = false;
    this.initAfterUsersTypeChange();
  }

  initAfterUsersTypeChange(){
    this.notifyUsersForm.get('usersSubType').setValue('');
    this.initAfterUsersSubTypeChange();
  }

  initAfterUsersSubTypeChange(){
    this.notifyUsersForm.get('apprType').setValue('All Approval Types');
    this.notifyUsersForm.get('rfspInclude').setValue(false);
  //  this.notifyUsersForm.get('emailSubject').setValue(null);
    // this.notifyUsersForm.get('emailBody').setValue(null);
    // this.notifyUsersForm.get('uploadImage').setValue(false);
  }
  uploadImageCheck(event){
    this.uploadImage = event.target.checked;
  }

   /**
     * @description Navigates to RecipinetsL ist
     */
  viewRecipientList() {
      this.tmssLoader.show();

      this.notifyUsersService.listOfRecipients(this.permission, this.notifyUsersForm.get('usersType').value, this.notifyUsersForm.get('usersSubType').value ).subscribe(data => {
                  //      console.log('auditTrailLogList data: ' + data);
        if (data) {

            this.emailRecipientList = data;
            // console.log('Successfully retrieved email lists And the length: ' + this.emailRecipientList.length);
            const initialState: any = {
              emailRecipientList: this.emailRecipientList
           // profile: this.profileName
            };
            this.bsModalRef = this.modalService.show(NotifyUsersEmailListComponent, { initialState, backdrop: 'static', class: 'modal-xl' });

        } else {
          this.alertService.error('No Recipients to display.');
        }
        this.tmssLoader.hide();
      }, (error) => {
        this.tmssLoader.hide();
        this.alertService.error('There was an error retrieving Email  List');
      });

  }

  onClickReviewEmail(){
     const initialState: any = {
              emailBody: this.notifyUsersForm.get('emailBody').value,
              emailSubject: this.notifyUsersForm.get('emailSubject').value,
              attachments: this.fileUploads
            };
    this.bsModalRef = this.modalService.show(PreviewNotificationEmailComponent, {initialState, backdrop: 'static', class: 'modal-xl' });
  }

  generateThreeItemLayout( src: string, fileName: string, fileSize :string, srcIcon: string): HTMLElement {
    this.layoutCounter += 1;
    const parentId = document.getElementById('selected_files')
    const containerId = `show_selected_files-${this.layoutCounter}`;
    const container = document.createElement("div");
    const formatFileName = this.truncateFileName(fileName);
    container.className = "three-item-layout";
    container.id = containerId;

    // Item 1: Image (no id)
    const item1 = document.createElement("div");
    item1.className = "item1";
    const img = document.createElement("img");
    img.src = src;
    img.alt = "";
    img.className = `usa-file-input__preview-image ${srcIcon}`;
    item1.appendChild(img);

    // Add file size span
    const sizeSpan = document.createElement("span");
    sizeSpan.className = "item1-size";
    sizeSpan.textContent =  "Size : " + fileSize;
    item1.appendChild(sizeSpan);

    // Item 3: Button
    const item3 = document.createElement("div");
    item3.className = "item3 tooltip-user";
    const btn = document.createElement("button");
    btn.className = "x-btn";
    btn.setAttribute("aria-label", "Remove");
    btn.textContent = "✖";
    const remove = () => {
      if (container.parentNode) {
        this.fileUploads = this.fileUploads.filter(fu => !(fu.id === container.id ));
        const isRemoved = container.parentNode.removeChild(container);
        this.resetFileInput();
      }
    };
    btn.onclick = remove;
    item3.appendChild(btn);

  // Add file size span
    const toolTipSpan = document.createElement("span");
    toolTipSpan.className = "tooltip-label";
    toolTipSpan.textContent =  "Remove this item";
    item3.appendChild(toolTipSpan);

    // Item 2: File name
    const item2 = document.createElement("div");
    item2.className = "item2";
    item2.textContent = `File Name : ${formatFileName}`;

    // Append in the desired order
    container.appendChild(item1);
    container.appendChild(item3);
    container.appendChild(item2);

    parentId.appendChild(container);
    return container;
  }

  resetFileInput(){
    const fileInput = document.getElementById('file-input-multiple') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  addFile(src: string, fileName: string, file?: File): string {
    // this.layoutCounter += 1;
    const containerId = `show_selected_files-${this.layoutCounter}`;

    const fileInfo: FileUpload = {
      id: containerId,
      src: src,
      fileName: fileName,
      file: file
    };

    this.fileUploads.push(fileInfo);
    return containerId;
  }


  onFilesSelected(event: Event): void {
    this.fileError = '';
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    // You can process the files here
    Array.from(input.files).forEach(file => {
      if (this.hasInvalidDots(file)) {
        this.fileError = file_upload_dots_error;
        return;
      }
      // For example, log file name and size
      const reader = new FileReader();
      reader.onload=() => {
      const extension = file.name.split('.').pop()?.toLowerCase() || 'default';
      const iconType = fileExtensionToIcon[extension] || fileExtensionToIcon['default'];
       const fileSize = Math.round(file.size / 1024) + 'KB';
      const srcS = typeof reader.result === "string" ? reader.result : "";
         const src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
         let srcIcon = "usa-file-input__preview-image--generic";
        switch (iconType) {
          case 'word':
            srcIcon = "usa-file-input__preview-image--word";
            break;
          case 'excel':
            srcIcon = "usa-file-input__preview-image--excel";
            break;
          case 'pdf':
            srcIcon = "usa-file-input__preview-image--pdf";
            break;
          case 'txt':
            srcIcon = "usa-file-input__preview-image--generic";
            break;
          default:
            break;
        }

        const srcFile = typeof reader.result === "string" ? reader.result : "";
        // const id = `show_selected_files-${this.layoutCounter}`;
        const layout = this.generateThreeItemLayout(src, file.name, fileSize, srcIcon);
         this.addFile(srcFile, file.name, file);
           const container = document.getElementById("file-layouts");
        if (container) {
          container.appendChild(layout);
        }
      };
       reader.readAsDataURL(file);
    });
  }

  truncateFileName(fullName: string, maxLength: number = 20): string {
    const lastDot = fullName.lastIndexOf('.');
    if (lastDot <= 0) {
      // No extension or hidden file (e.g. ".gitignore")
      return fullName.length > maxLength
        ? fullName.slice(0, maxLength - 3) + '...'
        : fullName;
    }

    const name = fullName.slice(0, lastDot);
    const ext = fullName.slice(lastDot); // this includes the dot and all after

    const allowedNameLength = maxLength - ext.length;
    if (fullName.length <= maxLength) return fullName;
    if (allowedNameLength <= 3) {
      // Not enough room for name, just show the last part of extension
      return '...' + ext;
    }
    return name.slice(0, allowedNameLength - 3) + '...' + ext;
  }

 buildNotifyUsersInput(): NotifyUsersInput {
    const notifyUsersin = new NotifyUsersInput();
    notifyUsersin.busType = this.permission;
    notifyUsersin.usersType = this.notifyUsersForm.get('usersType').value;
    notifyUsersin.usersSubType = this.notifyUsersForm.get('usersSubType').value;
    // notifyUsersin.apprType = this.notifyUsersForm.get('apprType').value;
    notifyUsersin.apprType = this.apprType;
    notifyUsersin.includeRfsps = this.notifyUsersForm.get('rfspInclude').value;
    notifyUsersin.emailSubject = this.notifyUsersForm.get('emailSubject').value;
    notifyUsersin.banner = this.notifyUsersForm.get('bannerImage').value;
    notifyUsersin.emailBody = this.notifyUsersForm.get('emailBody').value;
    notifyUsersin.attachments = this.uploadedFilesList.filter(item => item.status && item.status.toLowerCase() === 'done').map(item => item.message.replace(/~.*$/, ''));

    // Optionally clear the uploadedFilesList and withinUploadLimit flags
    this.uploadedFilesList = null;
    this.withinUploadLimit = false;

    return notifyUsersin;
  }

  hasInvalidDots(file) {
    // Case 1: two dots before the extension (e.g., test..pdf)
    const beforeExt = /\.\.[^.]+$/;
    // Case 2: two dots at the very end (e.g., test.pdf..)
    const afterExt = /\.\.$/;

    return beforeExt.test(file.name) || afterExt.test(file.name);
  }
}
